import { zodResolver } from '@hookform/resolvers/zod'
import { type ActionFunctionArgs } from 'react-router'
import { getValidatedFormData } from 'remix-hook-form'
import { z } from 'zod'
import { ContactUsForm } from '#app/components/layout/contact-us-form.tsx'
import { PageTitle } from '#app/components/layout/page-title.tsx'
import { ContactUsEmail } from '#app/emails/email-contact-us.tsx'
import { sendEmail } from '#app/utils/email.server.ts'

export const ContactUsSchema = z.object({
	name: z.string(),
	message: z.string(),
	email: z.string().email(),
	subject: z.string(),
})
export type ContactUsData = z.infer<typeof ContactUsSchema>
const resolver = zodResolver(ContactUsSchema)

const setOpen = () => {}

export async function action({ request }: ActionFunctionArgs) {
	const { data, errors } = await getValidatedFormData<ContactUsData>(
		request,
		resolver,
	)
	if (!data || errors) {
		return { error: errors.message }
	}
	const { subject, ...formData } = data
	const response = await sendEmail({
		subject,
		to: process.env.AKADEMIE_CONTACT_EMAIL,
		from: formData.email,
		react: <ContactUsEmail formData={data} />,
	})
	return { response }
}

export default function ContactUsRoute() {
	return (
		<div className="flex min-h-screen flex-col">
			<PageTitle titleText="Kontakt" />
			<div className="mx-auto flex max-w-6xl flex-col-reverse gap-8 px-8 py-16 md:flex-row">
				<div className="mx-auto w-full max-w-[500px] min-w-[400px]">
					<ContactUsForm setOpen={setOpen} showCancel={false} />
				</div>
				<div className="mx-auto">
					<h2 className="text-h2 font-alumni text-pcteal-default mt-4">
						Fragen oder Probleme?
					</h2>
					<p className="text-h2 font-alumni ml-8">Wir helfen gerne weiter!</p>
					<p className="mt-8">
						Du hast Fragen zu unseren Angeboten, brauchst Unterstützung bei der
						Nutzung unserer Plattform oder möchtest uns einfach etwas mitteilen?
						Dann zögere nicht, uns zu kontaktieren!
					</p>
					<p className="mt-8">
						Wir sind für dich da und helfen gerne weiter – egal, ob es um
						technische Probleme, inhaltliche Rückfragen oder Anregungen geht.
					</p>
					<p className="mt-8">
						Nutze einfach das Kontaktformular oder schreib uns direkt eine
						E-Mail an{' '}
						<a
							href="mailto:akademie@publicare.at"
							className="text-pcteal-default"
						>
							akademie@publicare.at
						</a>
						. Wir melden uns so schnell wie möglich bei dir!
					</p>
				</div>
			</div>
		</div>
	)
}
